export const withClientCheck = (WrappedComponent) => {
  return (props) => {
    if (typeof __CLIENT__ !== 'undefined' && __CLIENT__) {
      return <WrappedComponent {...props} />;
    }
    return null;
  };
};
